import { menuItems } from './MenuItems';
import MenuItems from './MenuItems';
const Navbar = ( {activePage} ) => {
    return (
        <nav>
            <ul className="menus">
                {menuItems.map((menu, index) => {
                    const depthLevel = 0;
                    return (
                        <MenuItems
                            items={menu}
                            depthLevel={depthLevel}
                            activePage={activePage}
                        />
                    );
                })}
            </ul>
        </nav>
    );
};

export default Navbar;